import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import SvgIcon from 'vue-svgicon';
import '@/components/icons';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import PrettyCheckbox from 'pretty-checkbox-vue';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/ru';
import Sticky from 'vue-sticky-directive';

Vue.use(Sticky);
Vue.use(DatePicker);
Vue.use(PrettyCheckbox);
Vue.use(HighchartsVue, {
	highcharts: Highcharts,
});
Highcharts.setOptions({
  lang: {
    loading: 'Загрузка...',
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    shortMonths: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек'],
    exportButtonTitle: "Экспорт",
    printButtonTitle: "Печать",
    rangeSelectorFrom: "С",
    rangeSelectorTo: "По",
    rangeSelectorZoom: "Период",
    downloadPNG: 'Скачать PNG',
    downloadJPEG: 'Скачать JPEG',
    downloadPDF: 'Скачать PDF',
    downloadSVG: 'Скачать SVG',
    printChart: 'Напечатать график'   
  }        
});

Vue.use(SvgIcon, {
  tagName: 'svgicon'
});

vSelect.props.components.default = () => ({
  OpenIndicator: {
    render: h => h('span', {class: {'toggle': true}}, [<svgicon name="arrow"></svgicon>]),
  },
});
Vue.component('v-select', vSelect);

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
